import { useStore } from "zustand";
import { usePresence } from "@/hooks/use-presence";
import { coreStore } from "@/lib/stores/core-store";
import { Avatar, AvatarFallback, AvatarImage } from "./avatar";
import { StatusIndicator } from "./status-indicator";

type AvatarWithStatusProps = {
	firebaseUid: string;
	initials: string;
	size?: "sm" | "md" | "lg";
	className?: string;
	profilePictureUrl?: string | null;
};

const sizeClasses = {
	sm: "size-6",
	md: "size-8",
	lg: "size-12",
};

const indicatorPositions = {
	sm: "bottom-0 right-0",
	md: "bottom-0 right-0",
	lg: "bottom-0.5 right-0.5",
};

export function AvatarWithStatus({
	firebaseUid,
	initials,
	size = "md",
	className,
	profilePictureUrl,
}: AvatarWithStatusProps) {
	const status = usePresence(firebaseUid);
	const storeProfilePictureUrl = useStore(
		coreStore,
		(state) => state.users.get(firebaseUid)?.profile.profilePhoto
	);
	const imageUrl = profilePictureUrl ?? storeProfilePictureUrl;

	return (
		<div className="relative size-fit">
			<Avatar className={className || sizeClasses[size]}>
				{imageUrl ? <AvatarImage alt={initials} src={imageUrl} /> : null}
				<AvatarFallback className="bg-linear-to-br from-purple-500 to-pink-500 text-sm text-white">
					{initials}
				</AvatarFallback>
			</Avatar>
			<div className={`absolute ${indicatorPositions[size]}`}>
				<StatusIndicator size="sm" status={status} />
			</div>
		</div>
	);
}
